// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import VueSessionStorage from 'vue-sessionstorage'
import router from './router'
import axios from 'axios'
import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import store from './store/store'
import JsonExcel from 'vue-json-excel'
import VModal from 'vue-js-modal'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import {library} from '@fortawesome/fontawesome-svg-core'
import {
  faAddressCard,
  faBatteryHalf,
  faBell,
  faCommentAlt,
  faComments,
  faExclamationCircle,
  faFileMedical,
  faFileMedicalAlt,
  faHeartbeat,
  faHistory,
  faLungs,
  faMale,
  faMapMarkerAlt,
  faPager,
  faPlayCircle,
  faPowerOff,
  faShoePrints,
  faStethoscope,
  faStopCircle,
  faThermometer,
  faThermometerHalf,
  faTint,
  faToggleOn,
  faTools,
  faMobile,
} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import DatePicker from 'vue-md-date-picker'
import i18n from './plugins/i18n'
import FlagIcon from 'vue-flag-icon'
import moment from 'moment'
import VueSocketIO from 'vue-socket.io'
import Notifications from 'vue-notification'
import Switches from 'vue-switches'
import LoadScript from 'vue-plugin-load-script'

const VueTouch = require('vue-touch')
VueTouch.registerCustomEvent('doubletap', {
  type: 'tap',
  taps: 1
})

Vue.use(VueSessionStorage)
Vue.use(VueTouch, {name: 'v-touch'})
Vue.use(Vuex)
Vue.use(VModal)

Vue.use(VueSidebarMenu)
Vue.use(DatePicker)
Vue.use(i18n)
Vue.use(FlagIcon)
Vue.use(Notifications)

Vue.use(LoadScript)

Vue.prototype.$http = axios
Vue.prototype.$axios = axios

library.add(faStethoscope, faHeartbeat, faThermometer, faThermometerHalf, faFileMedical, faAddressCard, faTools,
  faPowerOff, faComments, faLungs, faHistory, faToggleOn, faMale, faFileMedicalAlt, faPager, faShoePrints, faTint,
  faMapMarkerAlt, faBatteryHalf, faCommentAlt, faExclamationCircle, faBell, faStopCircle, faPlayCircle, faMobile,
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('v-select', vSelect)
Vue.component('downloadExcel', JsonExcel)
Vue.component('switches', Switches)

Vue.config.productionTip = false

Vue.use(new VueSocketIO({
  debug: false,
  connection: '',
  vuex: {
    store,
    actionPrefix: 'SOCKET_'
  }
}))

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY HH:mm')
  }
})

Vue.filter('formatDate2', function (value) {
  if (typeof value === 'number') {
    return moment.unix(value).format('DD.MM.YYYY HH:mm:ss')
  } else {
    return moment(value).format('DD.MM.YYYY HH:mm')
  }
})

let locale = localStorage.getItem('locale') || 'en'
i18n.locale = locale

Vue.prototype.$t = function (...args) {
  const result = this.$i18n.t.apply(this.$i18n, args)
  if (result === '') {
    return args[0]
  }
  return result
}

Vue.prototype.$tc = function (...args) {
  const result = this.$i18n.tc.apply(this.$i18n, args)
  if (result === '') {
    return args[0]
  }
  return result
}

/* eslint-disable no-new */
new Vue({
  store,
  el: '#app',
  router,
  i18n,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js